import React, { useState, useEffect, useCallback } from "react";
import { getBlockedUsers, unblockUser } from "api/community";
import { useSnackbar } from "contexts/SnackbarContext";
import SubHeader from "components/common/SubHeader";
import "pages/community/community.scss";

const BlockedUsers = () => {
    const { showError, showSuccess } = useSnackbar();
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const result = await getBlockedUsers();
                if (result.success) {
                    setUsers(result.data || []);
                }
            } catch {
                showError("차단 목록을 불러오지 못했습니다.");
            } finally {
                setIsLoading(false);
            }
        };
        load();
    }, [showError]);

    const handleUnblock = useCallback(async (userId) => {
        // 낙관적 업데이트
        setUsers((prev) => prev.filter((u) => u.user_id !== userId));
        try {
            const result = await unblockUser(userId);
            if (result.success) {
                showSuccess("차단이 해제되었습니다.");
            }
        } catch {
            showError("차단 해제에 실패했습니다.");
            // 롤백: 다시 불러오기
            const result = await getBlockedUsers();
            if (result.success) setUsers(result.data || []);
        }
    }, [showSuccess, showError]);

    return (
        <div className="community-page blocked-users-page">
            <SubHeader title="차단 사용자 관리" />

            <div className="blocked-users-content">
                {isLoading ? (
                    <div className="blocked-users-loading">불러오는 중...</div>
                ) : users.length === 0 ? (
                    <div className="empty-state">
                        <h3 className="empty-title">차단한 사용자가 없습니다</h3>
                    </div>
                ) : (
                    <div className="blocked-users-list">
                        {users.map((item) => (
                            <div key={item.user_id} className="blocked-user-item">
                                <div className="blocked-user-info">
                                    {item.user?.profile_image ? (
                                        <img src={item.user.profile_image} alt="" className="blocked-user-avatar" />
                                    ) : (
                                        <div className="blocked-user-avatar-placeholder">
                                            {(item.user?.nickname || item.user?.username || "?").charAt(0)}
                                        </div>
                                    )}
                                    <span className="blocked-user-nickname">{item.user?.nickname || item.user?.username || item.user_id || "알 수 없음"}</span>
                                </div>
                                <button
                                    className="blocked-user-unblock-btn"
                                    onClick={() => handleUnblock(item.user_id)}
                                >
                                    차단 해제
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlockedUsers;
